import { SupportingInfo } from "../supportingInfo";

type BlockInfos = { id: number | string; relatedSupportingInformation: SupportingInfo.RelatedSupportingInfo[] };

export const supportingInfoSignature = (info: SupportingInfo.RelatedSupportingInfo): string =>
  String(info.supportingInformation.parent ?? info.supportingInformation.id);

export interface SharedSupportingInfosResult {
  infos: SupportingInfo.RelatedSupportingInfo[];
  idMaps: Record<string, number | string>[];
  hasExtra: boolean;
}

export const computeSharedSupportingInfos = (blocks: BlockInfos[]): SharedSupportingInfosResult => {
  if (blocks.length === 0) return { infos: [], idMaps: [], hasExtra: false };

  const totalCount = blocks.reduce((sum, b) => sum + (b.relatedSupportingInformation?.length ?? 0), 0);
  const first = blocks[0].relatedSupportingInformation ?? [];
  const infos: SupportingInfo.RelatedSupportingInfo[] = [];
  const idMaps: Record<string, number | string>[] = [];

  first.forEach((candidate) => {
    const sig = supportingInfoSignature(candidate);
    const idMap: Record<string, number | string> = {};

    // If a block attaches the same root info more than once, only the first is tracked
    // in idMaps; hasExtra will be true to signal the unrepresented ones.
    const presentOnAll = blocks.every((b) => {
      const match = (b.relatedSupportingInformation ?? []).find((i) => supportingInfoSignature(i) === sig);
      if (!match || match.id === undefined) return false;
      idMap[String(b.id)] = match.id;
      return true;
    });

    if (presentOnAll && !infos.some((i) => supportingInfoSignature(i) === sig)) {
      infos.push({ ...candidate });
      idMaps.push(idMap);
    }
  });

  const hasExtra = totalCount > infos.length * blocks.length;
  return { infos, idMaps, hasExtra };
};
